import axios from 'axios';
import { getAccessToken } from './shared';
import { showWarningSnackbar } from '../components/snackBar/snakbar';
import { axiosInstanceForLambda } from './Axios';
import API_ENDPOINTS from '../apiEndpoints';
import { entityOptions } from '../utils/customerData';

export const FetchGstInDetails = async (gstin) => {
  try {
    const options = {
      method: 'GET',
      url: `${API_ENDPOINTS.REACT_APP_FETCH_GSTIN_URL}?gstin=${gstin}`,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    };

    const response = await axiosInstanceForLambda(options);
    return response;
  } catch (error) {
    console.log(error, 'error');

    const errorData = error?.response?.data || {};
    const errorCode = errorData?.error_cd;
    const isPortalUnavailable =
     error?.code === 'ERR_NETWORK' ||!error?.response ||[408, 500, 502, 503, 504].includes(error?.response?.status);

    const cachedMessage = errorData?.message || errorData?.errorMessage || errorData?.error;

    if (isPortalUnavailable) {
      showWarningSnackbar('GSTIN verification could not be completed as the portal is unavailable');
    } else if (errorCode === 'F08000' || errorCode === 'SWEB_9035') {
      showWarningSnackbar('Invalid GSTIN as per GST portal');
    } else if (cachedMessage) {
      showWarningSnackbar(cachedMessage);
    } else {
      showWarningSnackbar('Portal unavailable');
    }

    // 🔥 IMPORTANT: rethrow
    throw {
      code: errorCode || error?.code,
      message: cachedMessage,
      status: error?.response?.status,
      raw: error,
    };
  }
};

const constitutionToEntityMap = {
  'PUBLIC LIMITED COMPANY': 'PublicLtd',
  'PRIVATE LIMITED COMPANY': 'PvtLtd',
  'LIMITED LIABILITY PARTNERSHIP': 'LLP',
  LLP: 'LLP',
  PROPRIETORSHIP: 'Proprietorship',
  PROPRIETARY: 'Proprietorship',
  INDIVIDUAL: 'Individual',
  'HINDU UNDIVIDED FAMILY': 'HUF',
  HUF: 'HUF',
  GOVERNMENT: 'Government',
  TRUST: 'Trust',
  'ASSOCIATION OF PERSONS': 'AOP',
  AOP: 'AOP',
  'BODY OF INDIVIDUALS': 'BOI',
  BOI: 'BOI',
  PARTNERSHIP: 'Firm',
  'PARTNERSHIP FIRM': 'Firm',
  FIRM: 'Firm',
  'LOCAL AUTHORITY': 'LocalAuthority',
  'ARTIFICIAL JURIDICAL PERSON': 'ArtificialJuridicalPerson',
  AJP: 'ArtificialJuridicalPerson',
};

const normalizeConstitution = (value = '') => value.toString().trim().replace(/\s+/g, ' ').toUpperCase();

export const resolveEntityTypeFromGstin = ({ gstin = '', constitutionOfBusiness = '' } = {}) => {
  // Keep same approach used in customer flow: derive entity from PAN identifier in GSTIN.
  const entityChar = gstin?.trim()?.toUpperCase()?.charAt(5);
  const byPanIdentifier = entityOptions.find((ent) => ent?.panIdentifier === entityChar)?.id;
  if (byPanIdentifier) {
    return byPanIdentifier;
  }

  const normalizedConstitution = normalizeConstitution(constitutionOfBusiness);
  return constitutionToEntityMap[normalizedConstitution] || '';
};
